import { RecordTableButton } from '@common/types';

export const hasTableButtonsInHeader = (arrayButtons: Array<Array<RecordTableButton> | undefined>) => {
  return arrayButtons.some((buttons) => buttons?.length);
};
